(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }

  root.DecoGardenNewsletterSuccess = api;

  if (root.document && !root.__dgNewsletterSuccessLoaded) {
    root.__dgNewsletterSuccessLoaded = true;
    api.init(root, root.document);
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var FAMILY12_RETURN_TO = '/pages/family12#Family12Success';
  var DEFAULT_DELAY = 1400;
  var CONFETTI_COLORS = ['#22b573', '#660002', '#f5c65d', '#ffffff', '#ff8f70', '#6bcba1'];

  function isFamily12NewsletterForm(form) {
    if (!form || typeof form.matches !== 'function' || !form.matches('form.newsletter-form')) return false;
    if (typeof form.querySelector !== 'function') return false;

    var returnTo = form.querySelector('input[name="return_to"]');
    return Boolean(returnTo && returnTo.value === FAMILY12_RETURN_TO);
  }

  function setSubmittingState(form) {
    form.dataset.dgSuccessTransition = 'true';
    form.setAttribute('aria-busy', 'true');

    if (typeof form.querySelectorAll !== 'function') return;
    Array.prototype.forEach.call(form.querySelectorAll('[type="submit"]'), function (button) {
      button.disabled = true;
      if (typeof button.setAttribute === 'function') button.setAttribute('aria-disabled', 'true');
    });
  }

  function handleNewsletterSubmit(event, environment) {
    var env = environment || {};
    var form = event && event.target;

    if (!isFamily12NewsletterForm(form)) return false;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return false;

    if (form.dataset.dgSuccessTransition === 'true') return false;
    if (event && typeof event.preventDefault === 'function') event.preventDefault();

    setSubmittingState(form);

    if (typeof env.showSuccess === 'function') env.showSuccess(form);

    var schedule = typeof env.schedule === 'function' ? env.schedule : setTimeout;
    var delay = typeof env.delay === 'number' ? env.delay : DEFAULT_DELAY;
    schedule(function () {
      if (typeof env.submit === 'function') env.submit(form);
    }, delay);

    return true;
  }

  function createConfetti(document, reducedMotion, className) {
    if (reducedMotion || !document || typeof document.createElement !== 'function') return null;

    var container = document.createElement('div');
    container.className = className;
    container.setAttribute('aria-hidden', 'true');

    for (var index = 0; index < 28; index += 1) {
      var piece = document.createElement('span');
      piece.style.setProperty('--dg-confetti-x', ((index * 37 + 7) % 100) + '%');
      piece.style.setProperty('--dg-confetti-delay', ((index % 7) * 0.06).toFixed(2) + 's');
      piece.style.setProperty('--dg-confetti-duration', (1.55 + (index % 5) * 0.16).toFixed(2) + 's');
      piece.style.setProperty('--dg-confetti-drift', ((index % 5) - 2) * 24 + 'px');
      piece.style.setProperty('--dg-confetti-rotate', (180 + (index % 6) * 90) + 'deg');
      piece.style.setProperty('--dg-confetti-color', CONFETTI_COLORS[index % CONFETTI_COLORS.length]);
      container.appendChild(piece);
    }

    return container;
  }

  function makeElement(document, tagName, className, text) {
    var element = document.createElement(tagName);
    element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function showSuccessOverlay(root, document) {
    var existing = document.querySelector('[data-newsletter-success-overlay]');
    if (existing) return existing;

    var strings = root.dgNewsletterSuccessStrings || {};
    var reducedMotion = Boolean(
      root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
    var overlay = makeElement(document, 'div', 'dg-newsletter-success');
    overlay.setAttribute('data-newsletter-success-overlay', '');
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.setAttribute('aria-atomic', 'true');

    var confetti = createConfetti(document, reducedMotion, 'dg-newsletter-confetti');
    if (confetti) overlay.appendChild(confetti);

    var card = makeElement(document, 'div', 'dg-newsletter-success__card');
    var icon = makeElement(document, 'span', 'dg-newsletter-success__icon', '✓');
    icon.setAttribute('aria-hidden', 'true');
    var kicker = makeElement(
      document,
      'p',
      'dg-newsletter-success__kicker',
      strings.kicker || 'איזה כיף!'
    );
    var heading = makeElement(
      document,
      'h2',
      'dg-newsletter-success__heading',
      strings.heading || 'נרשמתם בהצלחה!'
    );
    var email = makeElement(
      document,
      'p',
      'dg-newsletter-success__email',
      strings.email || 'הקוד ל־10% הנחה כבר בדרך למייל'
    );
    card.appendChild(icon);
    card.appendChild(kicker);
    card.appendChild(heading);
    card.appendChild(email);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    var reveal = function () {
      overlay.classList.add('is-visible');
    };
    if (typeof root.requestAnimationFrame === 'function') root.requestAnimationFrame(reveal);
    else reveal();

    return overlay;
  }

  function resumeSecureSubmission(form) {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }

    var submitButton = typeof form.querySelector === 'function'
      ? form.querySelector('[type="submit"]')
      : null;
    if (!submitButton || typeof submitButton.click !== 'function') return;

    submitButton.disabled = false;
    if (typeof submitButton.removeAttribute === 'function') submitButton.removeAttribute('aria-disabled');
    submitButton.click();
  }

  function decorateFamily12Landing(marker, document, root) {
    if (marker.dataset && marker.dataset.dgConfettiReady === 'true') return;
    if (marker.dataset) marker.dataset.dgConfettiReady = 'true';

    var reducedMotion = Boolean(
      root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
    var confetti = createConfetti(document, reducedMotion, 'dg-family12-landing-confetti');
    if (!confetti) return;

    if (typeof marker.insertBefore === 'function') marker.insertBefore(confetti, marker.firstChild || null);
    else if (typeof marker.appendChild === 'function') marker.appendChild(confetti);

    if (typeof root.setTimeout === 'function') {
      root.setTimeout(function () {
        if (typeof confetti.remove === 'function') confetti.remove();
      }, 3600);
    }
  }

  function initFamily12Landing(root, document, options) {
    if (!document || typeof document.querySelector !== 'function') return false;
    var marker = document.querySelector('[data-family12-success]');
    if (!marker) return false;

    try {
      if (root.history && 'scrollRestoration' in root.history) root.history.scrollRestoration = 'manual';
    } catch (error) {
      // Some embedded browsers expose a read-only history object.
    }

    var resetTop = function () {
      if (typeof root.scrollTo === 'function') root.scrollTo(0, 0);
    };
    resetTop();

    if (typeof root.requestAnimationFrame === 'function') {
      root.requestAnimationFrame(function () {
        root.requestAnimationFrame(resetTop);
      });
    }

    if (typeof root.addEventListener === 'function') {
      root.addEventListener('load', resetTop, { once: true });
      root.addEventListener('pageshow', resetTop);
    }

    var decorate = options && typeof options.decorate === 'function'
      ? options.decorate
      : decorateFamily12Landing;
    decorate(marker, document, root);
    return true;
  }

  function restoreForms(document) {
    if (!document || typeof document.querySelectorAll !== 'function') return;

    Array.prototype.forEach.call(document.querySelectorAll('form.newsletter-form'), function (form) {
      if (!form.dataset || form.dataset.dgSuccessTransition !== 'true') return;
      delete form.dataset.dgSuccessTransition;
      form.removeAttribute('aria-busy');
      Array.prototype.forEach.call(form.querySelectorAll('[type="submit"]'), function (button) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      });
    });

    var overlay = document.querySelector('[data-newsletter-success-overlay]');
    if (overlay && typeof overlay.remove === 'function') overlay.remove();
  }

  function init(root, document) {
    document.addEventListener('submit', function (event) {
      handleNewsletterSubmit(event, {
        showSuccess: function () {
          showSuccessOverlay(root, document);
        },
        schedule: root.setTimeout.bind(root),
        submit: function (form) {
          resumeSecureSubmission(form);
        },
        delay: DEFAULT_DELAY,
      });
    }, true);

    initFamily12Landing(root, document);

    root.addEventListener('pageshow', function (event) {
      if (event.persisted && !document.querySelector('[data-family12-success]')) restoreForms(document);
    });
  }

  return {
    FAMILY12_RETURN_TO: FAMILY12_RETURN_TO,
    createConfetti: createConfetti,
    handleNewsletterSubmit: handleNewsletterSubmit,
    init: init,
    initFamily12Landing: initFamily12Landing,
    showSuccessOverlay: showSuccessOverlay,
  };
});
